import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex } from '@mantine/core';

interface Props {
	opened: boolean;
	loading: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const ResetTemplateDrawer = ({ opened, loading, onClose, onConfirm }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<GenericDrawer
			opened={opened}
			onClose={onClose}
			title={tMipManage('email_templates.editor.reset_confirm.title', {
				defaultValue: 'Reset to Dealstack default',
			})}
			body={
				<Flex direction="column" gap="1rem" h="100%">
					<Alert icon="danger-filled" state="dangerV3" size="s">
						<AlertTitle>
							{tMipManage('email_templates.editor.reset_confirm.alert_title', {
								defaultValue: 'This removes your changes',
							})}
						</AlertTitle>
						<AlertDescription>
							{tMipManage('email_templates.editor.reset_confirm.message', {
								defaultValue:
									'The subject and content of this template go back to the Dealstack default for this programme. This cannot be undone.',
							})}
						</AlertDescription>
					</Alert>

					<Flex direction="column" gap="0.5rem" mt="auto">
						<Button fullWidth loading={loading} onClick={onConfirm}>
							{tMipManage('email_templates.editor.reset_confirm.confirm_label', {
								defaultValue: 'Reset to default',
							})}
						</Button>
						<Button variant="default" fullWidth onClick={onClose}>
							{tMipManage('email_templates.editor.reset_confirm.cancel', {
								defaultValue: 'Cancel',
							})}
						</Button>
					</Flex>
				</Flex>
			}
		/>
	);
};
